<template>
	<div>
		<alert-success :class="'d-block shadow-sm'" :form="form" message="Policy updated successfully."></alert-success>

		<div v-if="loading">
			<spinner-component :loading="loading" />
		</div>

		<div v-if="!isEmpty(policy)">
			<div class="d-flex align-items-center justify-content-between mg-b-25">
				<h3 class="df-title">Manage Policy</h3>
				<div class="d-flex">
					<a href="#edit-policy" data-toggle="modal" class="btn btn-sm pd-x-15 btn-white shadow-sm"> <i data-feather="edit" class="wd-10 mg-r-5"></i>Update Policy</a>
				</div>
			</div>
			<div class="row">
				<div class="col-12">
					<label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Company</label>
					<p class="mg-b-0">{{ policy.company.name | placeholder }}</p>
				</div>
				<div class="col-12 mg-t-20 mg-sm-t-30">
					<label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Policy Type</label>
					<p class="mg-b-0">{{ policy.policy_type_details.name | placeholder }}</p>
				</div>
				<div v-if="policy.policy_type === 'APPROVAL_POLICY'" class="col-12 mg-t-20 mg-sm-t-30">
					<label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Number of Approvers Required</label>
					<p class="mg-b-0">{{ policy.number_of_approvers_required }}</p>
				</div>
				<div class="col-12 mg-t-20 mg-sm-t-30">
					<label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Approvers</label>
					<p v-for="(approver, index) in policy.meta_data_details" :key="index">{{ approver.name }}</p>
				</div>
				<div class="col-12 mg-t-20 mg-sm-t-30">
					<label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Requested By</label>
					<p class="mg-b-0">{{ policy.requested_by_details.name }}</p>
				</div>
				<div class="col-12 mg-t-20 mg-sm-t-30">
					<label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Approved By</label>
					<p class="mg-b-0">{{ policy.approved_by_details.name }}</p>
				</div>
			</div>

			<div class="modal" id="edit-policy" tabindex="-1" role="dialog" aria-hidden="true">
				<div class="modal-dialog" role="document">
					<form class="modal-content" @submit.prevent="updatePolicy">
						<div class="modal-header">
							<button type="button" class="close pos-absolute t-15 r-20" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
							<h5 class="modal-title">Update Policy</h5>
						</div>
						<div class="modal-body">
							<div v-if="!isEmpty(companyUsers)" class="form-group col-12">
								<label>Select Approvers</label>
								<select v-model="form.meta_data.approvers" id="approvers" class="form-control custom-select shadow-sm" multiple="multiple">
									<option v-for="(user, index) in companyUsers" :value="user.user_id" :key="index">{{ user.first_name + ' ' + user.last_name }}</option>
								</select>
							</div>
							<div class="form-group col-12">
								<label>Number of Approvers Required</label>
								<input
									v-model="form.number_of_approvers_required"
									type="number"
									min="1"
									class="form-control"
									:class="{ 'is-invalid': form.errors.has('form.meta.approvers') }"
									placeholder="Please enter number of approver need to approve"
									required
								/>
								<has-error :form="form" field="number_of_approvers_required"></has-error>
							</div>
						</div>
						<div class="modal-footer">
							<div class="wd-100p d-flex flex-column flex-sm-row justify-content-end">
								<button-component
									:busy="form.busy"
									:label="'Update Policy'"
									:label-loading="'Please wait...'"
									:button-class="'btn btn-default shadow-sm mg-b-5 mg-sm-b-0'"
								></button-component>
								<button type="button" class="btn btn-primary shadow-sm mg-sm-l-5" data-dismiss="modal">Cancel</button>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	created() {
		this.fetchPolicy();
	},
	data() {
		return {
			loading: true,
			policy: {},
			companyUsers: [],
			form: new Form({
				number_of_approvers_required: null,
				meta_data: {
					approvers: []
				}
			})
		};
	},
	methods: {
		fetchPolicy() {
			this.loading = true;

			axios
				.get(`/api/policies/${this.$route.params.policy}`)
				.then(
					({
						data: {
							data: { policy }
						}
					}) => {
						this.policy = policy;
						this.form.meta_data = policy.meta_data;
						this.form.number_of_approvers_required = policy.number_of_approvers_required;

						this.fetchCompanyUsers(policy.external_client_id);
					}
				)
				.catch(({ response }) => console.log(response))
				.finally(() => (this.loading = false));
		},
		fetchCompanyUsers(companyId) {
			axios
				.get(`/api/companies/${companyId}/users`, {
					params: {
						designation: 'approver'
					}
				})
				.then(({ data: { data } }) => (this.companyUsers = data.users))
				.catch(({ response }) => console.log(response));
		},
		updatePolicy() {
			this.form
				.patch(`/api/policies/${this.policy.id}`)
				.then(({ data: { data } }) => {
					this.fetchPolicy();
					$('#edit-policy').modal('hide');
				})
				.catch(({ response }) => console.log(response));
		}
	}
};
</script>

<style></style>
